import React, { useMemo } from "react";
import webui from "@tinqin/tinqin-web-ui";
import { xssFilter } from "../../../common/utils/xssFilter";
import { IComponentProps, IExtractedProps, SirenEntity } from "../../../common/utils/commonTypes";

export const BorderedBox: React.FC<IComponentProps> = props => {
    const data: SirenEntity["properties"] = props.data ? props.data.properties || {} : null;

    const dataProps: IExtractedProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["text", "title", "anchorId"]
    });
    const titleInnerHTML: string = useMemo(() => xssFilter.process(dataProps.title), [
        dataProps.title
    ]);
    const textInnerHTML: string = useMemo(() => xssFilter.process(dataProps.text), [
        dataProps.text
    ]);

    if (!data) {
        return null;
    }
    return (
        <div className="tq-flex-container" id={dataProps.anchorId ? dataProps.anchorId : null}>
            <div className="tq-flex-item un-left-border-box un-left-border-box-thin">
                <h2 className="tq-title">
                    <span
                        className="tq-text-node"
                        dangerouslySetInnerHTML={{
                            __html: titleInnerHTML
                        }}
                        data-hyperlinks-container={true}
                    />
                </h2>
                <div
                    dangerouslySetInnerHTML={{
                        __html: textInnerHTML
                    }}
                    data-hyperlinks-container={true}
                ></div>
            </div>
        </div>
    );
};

export default webui.connectComponent()(BorderedBox);
